import scrollTo from "@common/scroll-to";

const salesFormContainer = document.querySelector(".hubspot-form-sales");
const solutionTemplate = document.getElementById("solution-item-template");
const solutionsContainer = document.querySelector(".solutions-form-container");
const solutionsGrid = document.querySelector(".solutions-form-grid");
const checkboxContainer = document.querySelector(".validate-checkboxes");

const validateCheckboxes = () => {
  const customCheckboxes = checkboxContainer.querySelectorAll('.checkbox-wrapper input[type="checkbox"]:checked');
  const errorMessage = checkboxContainer.querySelector(".error-message") || document.createElement("div");

  if (!customCheckboxes.length) {
    errorMessage.classList.add("error-message");
    errorMessage.textContent = "Please select at least one option";

    if (!checkboxContainer.querySelector(".error-message")) {
      checkboxContainer.appendChild(errorMessage);

      const scrollOptions = {
        top: errorMessage,
        behavior: "smooth",
      };
      window.scrollTo(scrollOptions);
    }

    return false;
  } else {
    if (checkboxContainer.querySelector(".error-message")) {
      checkboxContainer.querySelector(".error-message").remove();
    }

    return true;
  }
};

const handleSolutions = () => {
  const fieldContainer = document.querySelector(".hs-form-field.hs_lead_source_product .inputs-list");
  const iconData = JSON.parse(document.getElementById("solutions-form-icons").textContent);

  if (!fieldContainer) {
    return;
  }

  fieldContainer.closest("fieldset").classList.add("hs-hidden");

  const checkboxes = fieldContainer.querySelectorAll('input[type="checkbox"]');

  if (!checkboxes.length) {
    return;
  }

  checkboxes.forEach((checkbox) => {
    const label = checkbox.parentNode.querySelector("span").textContent;
    const id = checkbox.id;
    const node = solutionTemplate.content.cloneNode(true);

    const foundIcon = iconData.icons.find((x) => x.label === label);
    const iconUrl = foundIcon?.icon ?? iconData._default;

    node.querySelector(".solution-label").textContent = label;
    node.querySelector("img").src = iconUrl;
    node.querySelector("img").alt = label;
    node.querySelector("input[type=checkbox]").id = `solution-${id}`;
    node.querySelector("label").setAttribute("for", `solution-${id}`);

    node.querySelector("input[type=checkbox]").addEventListener("change", (e) => {
      checkbox.checked = e.target.checked;
    });

    solutionsGrid.appendChild(node);
  });

  solutionsContainer.classList.remove("hidden");

  const form = salesFormContainer.querySelector("form");

  if (form) {
    form.addEventListener("submit", (e) => {
      if (!validateCheckboxes()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
};

if (salesFormContainer) {
  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        if (solutionsContainer.classList.contains("hidden")) {
          handleSolutions();
        }

        if (!salesFormContainer.querySelector("form")) {
          solutionsContainer.classList.add("hidden");

          setTimeout(() => {
            scrollTo(document.body);
          }, 500);

          observer.disconnect();
        }
      }
    }
  });

  observer.observe(salesFormContainer, { childList: true, subtree: true });
}
